import type { ProductPageViewModel, ProductSubscriptionInfoViewModel } from 'autogen/swagger/all';
import { createContext, useContext } from 'react';
import { createStore, useStore } from 'zustand';

type productStoreProps = {
    productId: ProductPageViewModel['productInformation']['productId'];
    isSubscription: ProductSubscriptionInfoViewModel['isSubscriptionSelected'];
};
type productState = productStoreProps & {
    setIsSubscription: (x: productStoreProps['isSubscription']) => void;
};

export type productStore = ReturnType<typeof createProductStore>;

export const createProductStore = (initProps: productStoreProps) => {
    return createStore<productState>()((set) => ({
        ...initProps,
        setIsSubscription: (isSubscription) => set((state) => ({ ...state, isSubscription }))
    }));
};

export const ProductContext = createContext<productStore | null>(null);

export function useProductStore() {
    const store = useContext(ProductContext);
    if (!store) throw new Error('Missing ProductContext.Provider in the tree');
    return useStore(store);
}
